module.exports = __webpack_public_path__ + "static/bkg-label-cow-v2-47a5406181142c619ab0c378de03c519.png";